// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

//import styles

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {MediaFileCard} from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues, getPatchReqData, getPostReqData,
    getTranslatableInputValues, getTranslationsInitialValues,
    initTranslations,
    toggleStateField
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {CreateVacancy, UpdateVacancyById, GetVacancyById,} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import {MAIN_LANGUAGE_TYPES} from "../../constants/constsTypes";
import {transformImage} from "../../utils/transformImage";
import {Switch} from "antd";

class AddEditVacancy extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields),
                image: null,
                salary: null,
                is_hidden: false,
                cvIsRequired: false,
                slug:'',
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: MAIN_LANGUAGE_TYPES.en,
            requestLoading: false,

        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditVacancy = this.addEditVacancy.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
    }

    async componentDidMount() {
        const {isEditing} = this.state;
        if (isEditing) {
            await this.props.GetVacancyById(this.props.id);
            const editingData = this.props.vacancyById;
            if (editingData) {
                const initStateData = {
                    translations: getTranslationsInitialValues(editingData.translations, ['title', 'description']),
                    slug: editingData?.slug || '',
                    image: editingData?.image_object_name ?
                        transformImage(editingData.image_object_name, editingData.image_url)
                        : null,
                    salary: editingData?.salary || null,
                    is_hidden: editingData?.is_hidden,
                    cvIsRequired: editingData?.cvIsRequired,

                }
                this.currentData = JSON.parse(JSON.stringify(initStateData));
                this.setState({
                    fieldsData: initStateData,
                });
            }
        }
    }

    getMedia(mediaArray) {
        const {fieldsData, errors} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                image: mediaArray[0],
            },
            errors: {
                ...errors,
                image: false
            }
        })
    }


    deleteMedia() {
        const {fieldsData,} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                image: null
            }
        })
    }

    async addEditVacancy() {
        await this.setState({
            requestLoading: true
        });
        const {translations, is_hidden, salary,slug,cvIsRequired} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']

        const validationTr = validateTranslations(translations, translationRequiredFields)
        // console.log('salary', salary);
        // console.log('validationTr', validationTr);
        let result = validationTr.result;
        const errors = {...validationTr.errors};

        // if (!image) {
        //     errors.image = true;
        //     result = false;
        // }

        if (!slug) {
            errors.slug = true;
            result = false;
        }

        if (result) {
            if (!this.state.isEditing) {
                let reqData = this.getPostReqData(this.state.fieldsData);
                console.log('create reqData', reqData)
                this.props.CreateVacancy(reqData).finally(() => {
                    this.setState({requestLoading: false});
                })
            } else {
                const reqData =this.getPostReqData(this.state.fieldsData);

                // reqData.image_object_name = image?.key || null;
                reqData.salary = salary || null;
                reqData.cvIsRequired = cvIsRequired;
                reqData.is_hidden = is_hidden;
                // console.log('update reqData', reqData)

                this.props.UpdateVacancyById(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalOpen,
            requestLoading,
            isEditing,
            errorsTabs,
        } = this.state;


        const initData = this.currentData?.translations?.find(item => item?.lang === languageTab) || {};
        const currentData = fieldsData.translations?.find(item => item?.lang === languageTab) || {};

        console.log(fieldsData.cvIsRequired,'fieldsData.cvIsRequiredfieldsData.cvIsRequired')
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Հաստիք' : 'Փոփոխել Հաստիքը'}>
            <section className="general-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.is_hidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.is_hidden}
                            onChange={(checked) => this.getInputValues({
                                name: "is_hidden",
                                value: !checked,
                                haveChanges: this.currentData?.is_hidden !== !checked
                            })}/>
                </div>
                <div className="fixed-top-right_cv">
                    <label>{fieldsData.cvIsRequired ? "Պահանջվում է CV " : "CV պարտադիր չէ"}</label>
                    <Switch checked={fieldsData.cvIsRequired}
                            onChange={(checked) => this.getInputValues({
                                name: "cvIsRequired",
                                value: checked,
                                haveChanges: this.currentData?.cvIsRequired !== checked
                            })}/>
                </div>
                {/*<div className="top-side">
                    <label> նկար <span className={'required-badge'}>*</span></label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn ${errors.image ? 'media-select-error' : ''}`}
                                cb={this.toggleMediaModal}
                    />
                </div>
                {fieldsData?.image && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.image}
                                   // customDelete={this.deleteMedia}
                    />
                </div>}*/}

                <InputGroup inputType="input"
                            type="text"
                            label="Slug"
                            placeholder="Slug"
                            name="slug"
                            required={true}
                            value={fieldsData?.slug}
                            initValue={this.currentData?.slug}
                            error={errors['slug']}
                            maxLength={100}
                            onChange={this.getInputValues}/>

                <InputGroup inputType="input"
                            type="text"
                            number={true}
                            integerNumber={true}
                            label="Աշխատավարձ"
                            placeholder="Աշխատավարձ"
                            name="salary"
                            value={fieldsData.salary}
                            initValue={this.currentData?.salary}
                            error={errors?.salary}
                            onChange={this.getInputValues}/>


                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            required={true}
                            onChange={this.getTranslationValues}/>
                <InputGroup inputType="textarea"
                            type="text"
                            label="Ենթավերնագիր"
                            placeholder="Ենթավերնագիր"
                            name="description"
                            value={currentData.description}
                            initValue={initData.description}
                            error={errors['description' + languageTab]}
                            maxLength={10000}
                            required={true}
                            onChange={this.getTranslationValues}/>
                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                cb={this.addEditVacancy}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreateVacancy,
    UpdateVacancyById,
    GetVacancyById,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditVacancy)
